import * as t from "./actionTypes"
import { setterAction } from "../common/redux"
import Source from "./Source"
import { transformResponse, publicProviderOrder, sortProviders } from "./common"
import { insuranceCaptureSubmitProvider } from "../integration/actions"
import { captureException } from "../common/error"


export const setRecommendations = setterAction(t.SET_RECOMMENDATIONS)
export const setOffices = setterAction(t.SET_OFFICES)
export const selectOffice = setterAction(t.SELECT_OFFICE)
export const setPlanProviders = setterAction(t.SET_PLAN_PROVIDERS)
export const selectPlanProvider = setterAction(t.SELECT_PLAN_PROVIDER)
export const setPlans = setterAction(t.SET_PLANS)
export const selectPlan = setterAction(t.SELECT_PLAN)
export const selectHolder = setterAction(t.SELECT_HOLDER)
export const setPlanInformation = setterAction(t.SET_PLAN_INFORMATION)

export const getAllPlanSettings = () => (dispatch, getState) => {
  let { planInformation } = getState().dashboard
  let { brand } = getState()

  Source.getOffices(brand ? brand.owner : "Buoy").then(data =>
    dispatch(setOffices(transformResponse(data, "address")))
  ).then(() => dispatch(selectOffice(planInformation.office)))

  Source.getPlanProviders(planInformation.office).then(data => {
    data = transformResponse(data)
    if (!brand || brand.owner === "Buoy") {
      // orders provider options for uhc provider capture 
      data = sortProviders(publicProviderOrder, data)
    }
    dispatch(setPlanProviders(data))
  }
  ).then(() => dispatch(selectPlanProvider(planInformation.plan_provider)))

  Source.getPlans(planInformation.office, planInformation.plan_provider).then(data => {
    dispatch(setPlans(transformResponse(data)))
    // Send only plan
    if (data[0]) {
      dispatch(onPlanResponse(data[0].token))
      // Very bad hacks
      if (data[0].name === "Other") {
        dispatch(onHolderResponse("NA"))
      } else {
        dispatch(selectHolder(planInformation.plan_holder))
      }
    }
  })
}

export const getPlanInformation = () => dispatch => {
  Source.getPlanInformation().then(data =>
    dispatch(setPlanInformation(data.detail ? false : data))
  )
}

export const getOffices = () => (dispatch, getState) => {
  const brand = getState().brand
  Source.getOffices(brand ? brand.owner : "Buoy").then(data =>
    dispatch(setOffices(transformResponse(data, "address")))
  )
}

export const onOfficeResponse = selected => dispatch => {
  dispatch(selectOffice(selected))
  dispatch(selectPlanProvider(null))
  dispatch(selectPlan(null))
  dispatch(selectHolder(null))
  Source.getPlanProviders(selected).then(data =>
    dispatch(setPlanProviders(transformResponse(data)))
  )
}

export const onPlanProviderResponse = selected => (dispatch, getState) => {
  const { office } = getState().dashboard
  dispatch(selectPlanProvider(selected))
  let selectedOffice = office.options.find(o => o.value === office.selected)
  if (selectedOffice && selectedOffice.text === "Public") {
  // only set plan and holder to null if they do not have public offices (for uhc provider capture)
    dispatch(insuranceCaptureSubmitProvider(selected))
  } else {
    dispatch(selectPlan(null))
    dispatch(selectHolder(null))
    Source.getPlans(office.selected, selected).then(data => {
      dispatch(setPlans(transformResponse(data)))
      // Send only plan
      if (data[0]) {
        dispatch(onPlanResponse(data[0].token))
        // Very bad hacks
        if (data[0].name === "Other") {
          dispatch(onHolderResponse("NA"))
        }
      }
    })
  }
}

export const onPlanResponse = selected => dispatch => {
  dispatch(selectPlan(selected))
  dispatch(selectHolder(null))
}

export const onHolderResponse = selected => dispatch => {
  dispatch(selectHolder(selected))
}

export const submitPlanInformation = () => (dispatch, getState) => {
  let { office, plan, holder } = getState().dashboard
  Source.submitPlanInformation(office.selected, plan.selected, holder).then(data => 
    dispatch(setPlanInformation(data))
  )
}

export const updatePlanInformation = () => (dispatch, getState) => {
  let { office, plan, holder } = getState().dashboard
  return Source.updatePlanInformation(office.selected, plan.selected, holder).then(data => 
    dispatch(setPlanInformation(data))
  )
}

export const getRecommendations = (count=0) => (dispatch, getState) => {
  const { integration, brand, dashboard } = getState()
  const { planInformation } = dashboard
  const { marketplaceToken } = integration

  if ((!brand.token || !marketplaceToken) && count < 10)
    return setTimeout(() => dispatch(getRecommendations(++count)), 1000)
  else if (count === 10) {
    captureException("Failed to get marketplace token after 10s.")
  }

  let query = {
    marketplace: marketplaceToken || brand.token,
  }

  if (planInformation) {
    const planInfo = {
      office: planInformation.office,
      plan: planInformation.plan,
      // Using underscores to convert easily to actual params using qs
      plan_provider: planInformation.plan_provider,
      plan_holder: planInformation.plan_holder
    }
    query = {...query, ...planInfo}
  }

  Source.getDashboardRecommendations(query)
    .then(data => {
      dispatch(setRecommendations(data.recommendations))
    })
}



// WEBPACK FOOTER //
// ./assets/dashboard/actions.js